export default {
    spedFiscal: {
        referenceYears: []
    },
    linkapitalSolicitation: {
        certificate: '',
        senha: ''
    }
}
